import LegalLayout from "@/components/LegalLayout";
import { PRIVACY } from "@/content/legal";

export default function Privacy() {
  return <LegalLayout doc={PRIVACY} />;
}
